import React, { useState } from "react";

export function ProductGallery({ images = [], title }) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState({ active: false, x: 50, y: 50 });
  const list = images.length ? images : [""];

  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoom({ active: true, x, y });
  };

  return (
    <div className="flex flex-col-reverse gap-4 md:flex-row md:gap-5">
      {/* Thumbnails */}
      {list.length > 1 && (
        <div className="flex gap-3 md:flex-col" data-testid="pdp-thumbnails">
          {list.map((img, i) => (
            <button
              key={img || i}
              onClick={() => setActive(i)}
              className={`h-16 w-16 shrink-0 overflow-hidden border transition-colors md:h-20 md:w-20 ${
                active === i ? "border-gold" : "border-border hover:border-gold/50"
              }`}
              aria-label={`View image ${i + 1}`}
            >
              <img src={img} alt={`${title} thumbnail ${i + 1}`} className="h-full w-full object-contain" />
            </button>
          ))}
        </div>
      )}

      {/* Main image with hover zoom */}
      <div
        className="relative aspect-square flex-1 cursor-zoom-in overflow-hidden bg-transparent"
        data-testid="pdp-gallery-main"
        onMouseEnter={() => setZoom((z) => ({ ...z, active: true }))}
        onMouseLeave={() => setZoom({ active: false, x: 50, y: 50 })}
        onMouseMove={onMove}
      >
        <img
          src={list[active]}
          alt={title}
          data-testid="pdp-gallery-image"
          className="h-full w-full object-contain object-center transition-transform duration-300"
          style={{
            transform: zoom.active ? "scale(1.9)" : "scale(1)",
            transformOrigin: `${zoom.x}% ${zoom.y}%`,
          }}
        />
      </div>
    </div>
  );
}
